import { ModalProps } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { Action, Dispatch } from "redux"
import { hideModal } from '../../store/actions/modal'
import { Modal } from './styles'

interface ComponentProps extends ModalProps {
  children
  name: string
  visibleModal: string
}

const Component = ({ children, name, visibleModal, onCancel, ...rest }: ComponentProps) => {
  const dispatch = useDispatch<Dispatch<Action>>()

  return (
    <Modal
      open={name === visibleModal}
      onCancel={event => {
        dispatch(hideModal())
        !!onCancel && onCancel(event)
      }}
      {...rest}
    >
      {children}
    </Modal>
  )
}

const state = ({ modalStore }) => {
  const { visibleModal } = modalStore
  return {
    visibleModal,
  }
}

export default connect(state)(Component)
